import Nango from '@nangohq/frontend'
import { toastStore } from 'shared/ui'
import { logger } from 'shared/lib'
import { type Integration, IntegrationsApi } from 'entities/Integrations'

export const nangoConnect = async (integration: Integration) => {
  const nango = new Nango()
  const connect = nango.openConnectUI({
    onEvent: async (event) => {
      if (event.type === 'connect') {
        try {
          await IntegrationsApi.createInstallation(integration.key, event.payload.connectionId)
          toastStore.add({
            type: 'success',
            title: `${integration.name} connected successfully`,
          })
          setTimeout(() => connect.close(), 100)
        } catch (e) {
          connect.close()
          toastStore.add({
            type: 'error',
            title: 'Something went wrong, try again!',
          })
          logger.error(e)
        }
      }
    },
  })
  try {
    const { data } = await IntegrationsApi.getConnectData(integration.key)
    connect.setSessionToken(data.data?.token)
  } catch (e) {
    connect.close()
    toastStore.add({
      type: 'error',
      title: 'Something went wrong, try again!',
    })
    logger.error(e)
  }
}
